import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SurveyExpiredPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '60px 40px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '90%'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '20px', color: '#e53e3e' }}>&#9888;</div>
        <h1 style={{ color: '#2d3748', margin: '0 0 16px', fontSize: '1.5rem' }}>
          {t('surveyExpired', 'title')}
        </h1>
        <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: 1.6 }}>
          {t('surveyExpired', 'message')}
        </p>
        <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: 1.6 }}>
          {t('surveyExpired', 'contact')}
        </p>
      </div>
    </div>
  );
};

export default SurveyExpiredPage;
